import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, TextInput } from 'react-responsive-ui'
import MessagesList from './messagesList';

class Chat extends Component {
    constructor(props) {
        super(props);
        this.props = props
        this.state = {
            messages: [],
        }
        this.handleNewMessage = this.handleNewMessage.bind(this)
        this.sendMessage = this.sendMessage.bind(this)
        this.getMessages()
    }   
    
    sendMessage() {
        if(this.props.channel){
            this.props.channel.sendMessage(this.state.newMessage)
            this.props.getChannels()
            
        }
        // this.props.channelSelected(this.props.activeConversation)
        this.getMessages()
        this.setState({newMessage: ''})
    }
    
    
    getMessages() {
        if (this.props && this.props.channel) {
            this.props.channel.getMessages().then(function (messages) {
                this.setState({ messages: messages.items })
            }.bind(this));
        }
    }
 
    handleNewMessage(newMessage) {
        this.setState({newMessage})
    }

    componentWillReceiveProps(props) {
        // console.log(props)
        if(this.props.channel !== props.channel) {
            this.props = props
        }

        if(this.props.channel){
            this.getMessages()
        }
    }

    render() {
        // console.log(`this.props.activeConversation = ${this.props.activeConversation}`)
        return (
         <div className="messages-container">
            <MessagesList activeChannel={this.props.channel} getMessages={this.getMessages} channel={this.props.channel} messages={this.state.messages} />
            {this.props.channel && <TextInput
                multiline
                focus
                placeholder="Type your message..."
                value={this.state.newMessage}
                onChange={this.handleNewMessage}
                onSubmit={this.sendMessage}
            />}
            {this.props.channel && <Button action={this.sendMessage}>Send</Button>}
        </div> 
            
        )
    }
}

Chat.propTypes = {
    history: PropTypes.object,
    channel: PropTypes.object,
    getChannels: PropTypes.func,
};
export default Chat;


// WEBPACK FOOTER //
// ./src/view/chat.js